import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32b3c258"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  "aria-label": "Submit button",
  class: "inline bg-black hover:bg-gray-800 active:bg-gray-900 p-5 rounded-tr-xl rounded-br-xl"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "11",
    height: "14"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "none",
      stroke: "#FFF",
      "stroke-width": "3",
      d: "M2 1l6 6-6 6"
    })
  ])
], -1))


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: String,
},
  emits: ['update:modelValue', 'submit'],
  setup(__props, { emit }) {





const onInput = (event: Event): void => {
  emit('update:modelValue', (event.target as HTMLInputElement).value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "flex items-stretch",
    onSubmit: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('submit')), ["prevent"]))
  }, [
    _createElementVNode("input", {
      type: "text",
      value: __props.modelValue,
      onInput: onInput,
      placeholder: "Search for any IP address or domain",
      class: "rounded-tl-xl rounded-bl-xl flex-grow pl-6 font-rubik text-lg text-gray-800"
    }, null, 40, _hoisted_1),
    _hoisted_2
  ], 32))
}
}

})